import { configure } from './config';
import differenceInDay from './helpers/differenceInDay.js';
import differenceInSeconds from './helpers/differenceInSeconds.js';
import { differenceInYear } from './helpers/differenceInYear';
import differenceWithNow from './helpers/differenceWithNow.js';
import format from './helpers/format.js';
import formatDuration from './helpers/formatDuration.js';
import formatISO from './helpers/formatISO.js';
import formatText from './helpers/formatText.js';
import { formatYears } from './helpers/formatYears';
import { getDurationText } from './helpers/getDurationText';
import { getNextMinute } from './helpers/getNextMinute';
import isHour12 from './helpers/isHour12.js';
import isLastWeek from './helpers/isLastWeek.js';
import isLastYear from './helpers/isLastYear.js';
import { isNextDay } from './helpers/isNextDay';
import isSameDay from './helpers/isSameDay.js';
import isToday from './helpers/isToday.js';
import { isValidTimestamp } from './helpers/isValidTimestamp';
import isYesterday from './helpers/isYesterday.js';
import millisecondToEndOfDay from './helpers/millisecondToEndOfDay.js';
import { now } from './helpers/now.js';
import nowWithOffset from './helpers/nowWithOffset.js';
import { parseTime } from './helpers/parseTime';
import secondsToString from './helpers/secondsToString.js';
import time from './helpers/time.js';

export * from './constants';

export default {
  now,
  isToday,
  isYesterday,
  isLastWeek,
  isLastYear,
  format,
  formatISO,
  formatText,
  differenceWithNow,
  differenceInSeconds,
  differenceInDay,
  differenceInYear,
  formatYears,
  isSameDay,
  secondsToString,
  formatDuration,
  nowWithOffset,
  time,
  parseTime,
  isHour12,
  millisecondToEndOfDay,
  getDurationText,
  getNextMinute,
  isValidTimestamp,
  isNextDay,
};

export { configure };
